/* screens/settings/BusinessTariffPanel.jsx — тариф бизнес-пространства (window.BusinessTariffPanel).
   Переиспользует window.BillingView (scope='business') — единые PlanCard/PaymentsList/UsageBar
   (фикс №15). 403 (?debug=403) обрабатывается внутри BillingView → ForbiddenState.
   canManage (админ/владелец выбранного бизнес-ws, приходит из BusinessSection) → когда false,
   BillingView прячет управление тарифом и показывает подсказку (бэк отдаёт 403 не-админу).
   ХЕНДОФФ → frontend/pages/settings/BusinessTariffPanel.jsx. */

import { BillingView } from './SubscriptionTab.jsx';

  function BusinessTariffPanel({ searchParams, wsId, canManage = true }) {
    return <BillingView scope="business" searchParams={searchParams} wsId={wsId} canManage={canManage} />;
  }

export { BusinessTariffPanel };
